import { Container, createStyles } from '@mantine/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import CustomAccordion from '../components/CustomAccordion';
import Fab from '../components/Fab/Fab';
import ProfileBanner from '../components/ProfileBanner';
import Abilities from '../components/Resume/Abilities/Abilities';
import Aptitudes from '../components/Resume/Aptitudes/Aptitudes';
import Courses from '../components/Resume/Courses/Courses';
import Education from '../components/Resume/Education/Education';
import Experience from '../components/Resume/Experience';
import Languages from '../components/Resume/Languages/Languages';
import { LANGUAGES } from '../config/constants';

const useStyles = createStyles((theme) => ({
  root: {
  },
  container: {
    [theme.fn.smallerThan('sm')]: {
      padding: 0,
    },
  },
}));

const PAGE_ROUTE = '/';

export default function Resume() {
  const { t, i18n } = useTranslation();
  const { classes } = useStyles();
  const { lang } = useParams();
  const navigate = useNavigate();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  React.useEffect(() => {
    if (lang && LANGUAGES.find((l) => l.code === lang)) {
      changeLanguage(lang);
      navigate('/');
    }
  }, []);

  return (
    <Container className={classes.container}>
      <ProfileBanner />
      <Aptitudes />
      <div id="experience"><CustomAccordion hash="experience" title={t('experience.title')} content={<Experience />} /></div>
      <div id="languages"><CustomAccordion hash="languages" title={t('languages.title')} content={<Languages />} /></div>
      <div id="education"><CustomAccordion hash="education" title={t('education.title')} content={<Education />} /></div>
      <div id="courses"><CustomAccordion hash="courses" title={t('courses.title')} content={<Courses />} /></div>
      <div id="abilities"><CustomAccordion hash="abilities" title={t('abilities.title')} content={<Abilities />} /></div>

      <Fab pageRoute={PAGE_ROUTE} />
    </Container>
  );
}
